// import React, { useEffect } from 'react'
import { useEnvVar } from 'utils/envConfig'
import { useAuth } from 'react-oidc-context'

function StripeBilling() {
  const auth = useAuth();
  const { value: STRIPE_PRICING_TABLE, loading: tableLoading, error: tableError } = 
    useEnvVar('STRIPE_PRICING_TABLE', auth.user?.access_token);
  const { value: STRIPE_KEY, loading: keyLoading, error: keyError } = 
    useEnvVar('stripe_publishable_api_key', auth.user?.access_token);

  return (
    <div style={{ width: '100%' }}>
      <stripe-pricing-table
        pricing-table-id={STRIPE_PRICING_TABLE}
        publishable-key={STRIPE_KEY}
      ></stripe-pricing-table>
    </div>
  )
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

export default StripeBilling